import { PrimaryButton } from '@client/new/components/button';
import { navigate, PATHS } from '@client/routes';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useSignUpStore } from '../../../stores/sign-up.store';
import { AuthLayout } from '../auth.layout';
import { Progress } from './progress';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { muiForm } from '@client/new/helpers/forms';
import { TextField, Typography } from '@mui/material';
import { mixTrack, track } from '@services/mixpanel';
import { instagramUsernameValidation } from '../../commonValidation';

const schema = z.object({
  profileInstagram: instagramUsernameValidation,
});

export const FillInstagramStepPage = () => {
  const { setProfileInstagram, profileInstagram, email } = useSignUpStore();

  const { register, handleSubmit, watch } = muiForm(
    useForm({
      defaultValues: {
        profileInstagram,
      },
      resolver: zodResolver(schema),
    }),
  );

  const onSubmit = useCallback(async (values: { profileInstagram: string }) => {
    track({ type: 'Instagram Submitted', payload: { uid: '' } });
    const instagramHandle = values.profileInstagram.trim().toLowerCase();
    setProfileInstagram(instagramHandle);
    navigate(PATHS.SIGN_UP_CONFIRMATION_CODE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const complete = watch('profileInstagram')?.length;

  if (!email) {
    navigate(PATHS.SIGN_UP);
    return null;
  }

  const handleContinueClick = () => {
    mixTrack({
      type: 'Instagram Submitted',
      payload: {},
    });
  };

  return (
    <AuthLayout showGoBack title={'Help us get to know you 🌝'}>
      <div className="flex flex-col  w-full items-center">
        <Typography variant="body1" className="text-center mt-12">
          Help new members get to know you better by linking to your Instagram
          profile.
        </Typography>
        <form
          className="mt-8 w-full flex flex-col gap-3 text-left"
          onSubmit={handleSubmit(onSubmit)}
        >
          <TextField
            autoFocus
            aria-label="First name"
            type="text"
            label="Instagram handle"
            InputProps={{
              startAdornment: <span className="pr-1">@</span>,
              placeholder: 'Instagram.username',
            }}
            {...register('profileInstagram')}
          />
          <PrimaryButton
            large
            type="submit"
            className={`w-full mt-5`}
            disabled={!complete}
            onClick={handleContinueClick}
          >
            Continue
          </PrimaryButton>
        </form>

        <div className="absolute bottom-4">
          <Progress steps={2} stepsCompleted={2} />
        </div>
      </div>
    </AuthLayout>
  );
};
